<template>
  <div class="card">
    <div class="card-header">
      <i class="fa fa-mobile"></i>Notifications & événements
    </div>

    <div class="card-block">
      <Tabs v-model="activeTab">
        <Tab header="Popups">
          <CoachAppDynamicContentTable
            :dynamicContentData="coach.dynamicContentRelations"
          />
        </Tab>

        <Tab header="Assistant">
          <CoachAppEventsTable
            eventType="assistantEvents"
            :eventsData="coach.assistantEvents"
          />
        </Tab>

        <Tab header="Notifications">
          <CoachAppEventsTable
            eventType="userEvents"
            :eventsData="coach.userEvents"
          />
        </Tab>
      </Tabs>
    </div>
  </div>
</template>

<script>
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";

import CoachAppEventsTable from "@/components/coach/CoachAppEventsTable.vue";
import CoachAppDynamicContentTable from "@/components/coach/CoachAppDynamicContentTable.vue";

export default {
  components: {
    Tabs,
    Tab,
    CoachAppEventsTable,
    CoachAppDynamicContentTable,
  },

  props: {
    coach: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      activeTab: 0,
    };
  },
};
</script>
